module.exports = __webpack_public_path__ + "static/img/1banner.9548f1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/recycle/1banner.png
// module id = 0L3c
// module chunks = 1